import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'El acceso es inmediato. Apenas se confirma el pago por Mercado Pago, recibís un mail automático con el link para descargar todos los PDFs (los tomos y los bonos) a tu computadora, tablet o celular.'
  }, {
    q: '¿Sirve si recién me recibí?',
    a: 'Es exactamente para vos. Los tomos están diseñados para llenar el vacío que deja la facultad: la formación clínica la tenés — los protocolos de comunicación no te los enseñó nadie, y acá están todos.'
  }, {
    q: '¿Los PDFs son editables o solo los puedo leer?',
    a: 'Las plantillas (consentimientos, checklist, tarjeta de cierre, plantilla de presupuesto) están diseñadas para imprimir, completar a mano o adaptar a los datos de tu clínica. Los tomos son PDFs de lectura con diseño profesional.'
  }, {
    q: '¿Los 3 bonos están incluidos en las dos ofertas?',
    a: 'Sí. Los 3 bonos (consentimientos, checklist y guía de frases) están incluidos tanto en el Kit Pro como en el Megapack Pro sin costo adicional.'
  }, {
    q: '¿Cuánto tiempo me lleva aplicarlo?',
    a: 'El primer resultado lo notás en la primera consulta después de leer el tomo correspondiente a tu situación. No tenés que terminar la colección — abrís el tomo que necesitás hoy y lo aplicás hoy.'
  }, {
    q: '¿Qué diferencia tiene con los libros de comunicación médica?',
    a: 'Los libros existentes están escritos por psicólogos o coaches con ejemplos de medicina humana. Este material habla tu idioma: el ejemplo es de un Golden Retriever con linfoma, el propietario difícil es la señora que llegó con un video de YouTube, y los guiones están probados en el contexto veterinario argentino.'
  }, {
    q: '¿Por qué elegir el Megapack Pro y no el Kit Pro?',
    a: 'Si la incomodidad para hablar de dinero o manejar propietarios que se desbordan emocionalmente es parte de tu día a día — el Megapack Pro es para vos. Los Tomos 7 y 8 cubren los dos momentos donde el veterinario argentino más se siente solo y sin herramientas.'
  }, {
    q: '¿Tiene garantía real?',
    a: '100% real. 7 días desde la compra. Si no es lo que esperabas, nos escribís a contacto@solucionesya.shop y te devolvemos el dinero completo. Sin preguntas.'
  }];
  return <section className="bg-white py-10 sm:py-16 px-5" data-id="element-70">
      <div className="max-w-6xl mx-auto" data-id="element-71">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-green mb-2 sm:mb-3" data-id="element-72">
          Dudas comunes
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-navy mb-8 sm:mb-12 leading-tight" data-id="element-73">
          Preguntas frecuentes
        </h2>

        <div className="max-w-3xl mx-auto" data-id="element-74">
          {faqs.map((faq, i) => <div key={i} className="border-b border-gray-200" data-id="element-75">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} className="w-full text-left py-3.5 sm:py-5 flex justify-between items-center gap-3 sm:gap-4 text-xs sm:text-base font-semibold text-navy hover:text-green transition-colors" data-id="element-76">
                {faq.q}
                <span className="text-xl sm:text-2xl text-green flex-shrink-0" data-id="element-77">
                  {openIndex === i ? '−' : '+'}
                </span>
              </button>
              <AnimatePresence data-id="element-78">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-79">
                    <p className="text-[11px] sm:text-base text-gray-700 leading-relaxed pb-4 sm:pb-5" data-id="element-80">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}